// extracted by mini-css-extract-plugin
module.exports = {"composeNextToInput":"ComposeNextToInput__composeNextToInput__6pnXf","addTag":"ComposeNextToInput__addTag__obYYS","error":"ComposeNextToInput__error__nc+84"};